import { faShieldHalved } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { HighlightedText } from 'components/text/HighlightedText';
import { FaultTypeTreeItem } from 'pages/Desk/issues/fault_type/styled';
import { IssueFaultType } from 'pages/Desk/issues/fault_type/useFaultTypes';
import { memo } from 'react';
import { TreeNode } from 'shared/data_tree/types';

export type FaultTypeNodeProps = Readonly<{
    node: TreeNode<IssueFaultType>;
    filterText: string;
}>;

function FaultTypeNode({ node, filterText }: FaultTypeNodeProps) {
    const faultTypeName = node.isRoot ? node.data.name.toUpperCase() : node.data.name;

    return filterText ? (
        <FaultTypeTreeItem $isRoot={node.isRoot}>
            <HighlightedText text={faultTypeName} terms={[filterText]} />
        </FaultTypeTreeItem>
    ) : (
        <FaultTypeTreeItem $isRoot={node.isRoot}>
            <div>{faultTypeName}</div>
            {node.data.internalOnly && <FontAwesomeIcon icon={faShieldHalved} />}
        </FaultTypeTreeItem>
    );
}

const memoFaultTypeNode = memo(FaultTypeNode);
export { memoFaultTypeNode as FaultTypeNode };
